import { post } from './http';
import { dataLayerAddToCart } from '../Services/Gtm.service';

export const add = async ({ articleNumber, quantity = 1, price, currency }) => {
    if (!quantity || isNaN(quantity) || parseInt(quantity) <= 0) {
        throw "Invalid quantity";
    }

    if(window.pintrk != undefined){

        pintrk('track', 'addtocart', {
            value: price,
            order_quantity: parseInt(quantity),
            currency: currency,
            line_items: [
                {
                    product_id: articleNumber,
                    product_quantity: parseInt(quantity)
                }
            ]
            });
    }

    const response = await post('/api/cart/add', { articleNumber, quantity: parseInt(quantity) });

    var result = await response.json();

    try {
      addToDataLayer([{ articleNumber, quantity }], result.orderRows);
    } catch (err) {
      console.log(err);
    }

    return result;
}

export const reorder = async (orderId) => {
    const response = await post('/api/cart/reorder', { orderId });
    return response.json();
}

export const addMultiple = async ({articles, currency}) => {
    //TODO more validation, probably
    // if(articles.length == 0){
    //     throw "Invalid collection";
    // }
    // if(window.)
    if(window.pintrk != undefined){

        var totalValue = 0;
        var totalQuantity = 0;
        var lineitems = [];
        articles.forEach(element => {
            totalValue += parseInt(element.price);
            totalQuantity += parseInt(element.quantity);
            lineitems.push({
                product_id: element.articleNumber,
                product_quantity: parseInt(element.quantity)
            });
        });

        pintrk('track', 'addtocart', {
            value: totalValue,
            order_quantity: totalQuantity,
            currency: currency,
            line_items: lineitems
            });
    }

    const response = await post('/api/cart/addMultiple', { items: articles});
    return response.json();
}

const addToDataLayer = (products, orderRows) => {
  let responseProducts = [];
  orderRows.forEach((row) => {
    for (const i in products) {
      if (Object.hasOwnProperty.call(products, i)) {
        if (products[i].articleNumber === row.articleNumber) {
          const index = responseProducts.findIndex(
            (e) => e.articleNumber === row.articleNumber
          );
          if (index === -1) {
            row.gtmEcommerceItem.quantity = parseInt(products[i].quantity);
            row.gtmEcommerceItem.index = responseProducts.length;
            responseProducts.push(row);
          }
        }
      }
    }
  });

  const gtmEcommerceItems = responseProducts.map(
    (p) => p.gtmEcommerceItem
  );
  if (gtmEcommerceItems) {
    dataLayerAddToCart(gtmEcommerceItems);
  }
};
